class Toc extends HTMLElement {
  #observer = null;
  #links = new Map();

  connectedCallback() {
    const source = this.closest("article")?.querySelector("[data-scpd-toc-source]");
    const list = this.querySelector("[data-scpd-toc-list]");
    if (!source || !list) return;

    const headings = [...source.querySelectorAll("h2")];
    if (headings.length < 2) return;

    const used = new Set();
    for (const heading of headings) {
      if (!heading.id) heading.id = this.#slug(heading.textContent, used);
      used.add(heading.id);

      const item = document.createElement("li");
      const link = document.createElement("a");
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      item.append(link);
      list.append(item);
      this.#links.set(heading, link);
    }

    if (!matchMedia("(min-width: 990px)").matches) {
      this.querySelector("details")?.removeAttribute("open");
    }
    this.hidden = false;

    // The -66% bottom margin makes a heading current once it passes a line a third of the way down.
    this.#observer = new IntersectionObserver(this.#onCross, {
      rootMargin: "0px 0px -66% 0px",
    });
    headings.forEach((heading) => this.#observer.observe(heading));
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  #onCross = (entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      for (const [heading, link] of this.#links) {
        link.classList.toggle("is-current", heading === entry.target);
      }
    }
  };

  #slug(text, used) {
    const base =
      text
        .toLowerCase()
        .normalize("NFKD")
        .replace(/[̀-ͯ]/g, "")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "")
        .slice(0, 60) || "section";
    let slug = base;
    let n = 2;
    while (used.has(slug) || document.getElementById(slug)) slug = `${base}-${n++}`;
    return slug;
  }
}

if (!customElements.get("scpd-toc")) customElements.define("scpd-toc", Toc);
